var $ = require('jquery');

$(function () {
    $('.our-firms').each(function() {
        var $this,
            clearLink;

        $this = $(this);

        var table = $('.our-firms-wrapper');
        var allRows = $('.firm-row');
        var visibleRows = null;

        $('.service-filter').change(function (e) {
            e.preventDefault();
            filterTable();
        });

        $('.city-filter').change(function (e) {
            e.preventDefault();
            filterTable();
        });

        clearLink = $this.find('[data-clear-filters]');
        clearLink.hide();

        clearLink.on('click', function (e) {

            $this.find('input[type=checkbox]:checked').each(function () {
                var $this = $(this);
                $this.removeAttr('checked');
                $this.prop('checked', false);
            });

            filterTable();
        });

        $('[data-show-more-locations], [data-show-less-locations]').click(function (e) {
            e.preventDefault();
            $(this).closest('.our-firms__firm__offices')
                .find('[data-show-more-locations], [data-show-less-locations], [data-show-more-cities]')
                .toggleClass('is-hidden');
        });

        function filterTable() {
            // Re-attach everything for searching.
            if (visibleRows != null) {
                visibleRows.detach();
                allRows.appendTo(table);
                visibleRows = null;
            }

            visibleRows = getVisibleRows('service', allRows);
            visibleRows = getVisibleRows('city', visibleRows);

            if ($this.find('.service-filter:checked,.city-filter:checked').length)
                clearLink.show();
            else
                clearLink.hide();

            // Detach and re-attach only the visible rows.
            allRows.detach();
            visibleRows.appendTo(table);
        }

        function getVisibleRows(filterName, startingRows) {
            var chosenFilterElements = $('.' + filterName + '-filter:checked');
            if (chosenFilterElements.length === 0)
                return startingRows;

            var endingRows = startingRows.filter(function (idx, element) {
                var firmFilterItems = $(element).find('.' + filterName);

                for (var i = 0; i < chosenFilterElements.length; i++) {
                    var chosenFilterId = $(chosenFilterElements[i]).data(filterName + '-id');

                    // Exclude this row if it doesn't have one of the chosen items.
                    var isFound = false;
                    for (var fi = 0; fi < firmFilterItems.length; fi++) {
                        if ($(firmFilterItems[fi]).data(filterName + '-id') === chosenFilterId) {
                            isFound = true;
                            break;
                        }
                    }
                    if (!isFound)
                        return false;
                }
                return true;
            });

            return endingRows;
        }
    });
});